<div class="launch-modal-backdrop" *ngIf="isVisible$ | async" [class.zoom-out-backdrop]="isZoomingOut">
  <div class="launch-modal-container" [class.zoom-out-container]="isZoomingOut">
    <button class="close-button" (click)="closeModal()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>

    <div class="launch-modal-content">
      <div class="launch-header-center">
        <h3 class="dept-title">{{ t.deptTitle }}</h3>
        <p class="presents-text">{{ t.presents }}</p>
        <h1 class="portal-title">{{ t.portalTitle }}</h1>
      </div>

      <div class="launch-modal-grid">
        <div class="launch-date-box" [ngClass]="{'launched': isLaunched}">
          <span class="date-label">{{ t.launchDateLabel }}</span>
          <span class="date-value">{{ launchService.LAUNCH_DATE | date:'mediumDate' }}</span>

          <div class="countdown-timer" *ngIf="!isLaunched">
            <div class="time-block">
              <span class="time-number">{{timeLeft.days | number:'2.0-0'}}</span>
              <span class="time-label">{{ t.days }}</span>
            </div>
            <span class="time-sep">:</span>
            <div class="time-block">
              <span class="time-number">{{timeLeft.hours | number:'2.0-0'}}</span>
              <span class="time-label">{{ t.hours }}</span>
            </div>
            <span class="time-sep">:</span>
            <div class="time-block">
              <span class="time-number">{{timeLeft.minutes | number:'2.0-0'}}</span>
              <span class="time-label">{{ t.minutes }}</span>
            </div>
            <span class="time-sep">:</span>
            <div class="time-block">
              <span class="time-number">{{timeLeft.seconds | number:'2.0-0'}}</span>
              <span class="time-label">{{ t.seconds }}</span>
            </div>
          </div>
          <div class="launched-message" *ngIf="isLaunched">
            {{ t.regOpen }}
          </div>
        </div>

        <div class="launch-divider" style="margin: 0 auto;"></div>

        <p class="launch-message concise-message" [innerHTML]="t.announcement"></p>

        <div class="launch-video-section">
          <h3 class="video-title" style="text-align: center;">{{ t.tutorialTitle }}</h3>
          <div class="videos-grid">
            <div class="video-container">
              <iframe src="https://www.youtube.com/embed/X5eGEg0NGoo" title="Amakalakara Registration Video 1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
            </div>
            <div class="video-container">
              <iframe src="https://www.youtube.com/embed/n5-9m5IsPTA" title="Amakalakara Registration Video 2"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
            </div>
            <div class="video-container">
              <iframe src="https://www.youtube.com/embed/N9AKFb11pO8" title="Amakalakara Registration Video 3"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
            </div>
          </div>
        </div>

        <p class="launch-sub-message" *ngIf="!isLaunched" style="margin-top: 24px;">
          {{ t.subMessage }}
        </p>

        <button class="btn btn-primary explore-btn" (click)="closeModal()">
          {{ isLaunched ? t.enterNow : t.exploreSite }}
        </button>

        <!-- Flower Animation Overlay -->
        <div class="flower-overlay" *ngIf="isLaunched">
          <div class="flower f1">💐</div>
          <div class="flower f2">🌸</div>
          <div class="flower f3">🌺</div>
          <div class="flower f4">🌷</div>
          <div class="flower f5">🌻</div>
          <div class="flower f6">🌼</div>
          <div class="flower f7">🌺</div>
          <div class="flower f8">💐</div>
        </div>
      </div>
    </div>
  </div>